import { getEnv } from '../../../lib/env';
import { syncSpace as syncSpaceApiCall } from '../../../lib/flotiq-client/external-services-requests';
import { parseResponseErrors } from '../../../lib/flotiq-client/response-errors';
import { removeTrailingSlash } from '../../../lib/helpers';

import { ErrorType, PopulateSpaceError } from './PopulateSpaceError';

export const syncSpace = async (
  targetRwApiKey: string,
  sourceRwApiKey: string,
) => {
  try {
    const { body, status, ok } = await syncSpaceApiCall(
      undefined,
      undefined,
      undefined,
      {
        body: JSON.stringify({
          sourceApiUrl: `${removeTrailingSlash(
            getEnv('VITE_FLOTIQ_ONBOARDING_APPS_CTD_URL').split(
              '/api/v1/content/',
            )[0],
          )}/api/v1/`,
          sourceApiKey: sourceRwApiKey,
          targetApiUrl: `${removeTrailingSlash(getEnv('VITE_FLOTIQ_API_URL'))}/api/v1/`,
          targetApiKey: targetRwApiKey,
        }),
      },
    );

    if (!ok) {
      throw parseResponseErrors(body, status);
    }
  } catch (e) {
    if (e instanceof Error) {
      throw new PopulateSpaceError(e.message, ErrorType.SYNC_SPACE);
    }
  }
};

export default syncSpace;
